import React from 'react';
const DELIVERIES = [
  { id: 'DEL-891', supplier: 'Valley Fresh Produce', po: 'PO-2400', items: 28, expected: '7:00 AM', arrived: '7:15 AM', status: 'Inspecting', dock: 'Dock 1' },
  { id: 'DEL-890', supplier: 'Pacific Dairy Co.', po: 'PO-2399', items: 12, expected: '8:00 AM', arrived: '7:55 AM', status: 'Accepted', dock: 'Dock 2' },
  { id: 'DEL-889', supplier: 'Western Meats Ltd', po: 'PO-2398', items: 8, expected: '9:30 AM', arrived: '-', status: 'Pending', dock: 'Dock 1' },
  { id: 'DEL-888', supplier: 'Ocean Catch Seafood', po: 'PO-2397', items: 6, expected: '10:00 AM', arrived: '-', status: 'Pending', dock: 'Dock 3' },
];
const SC = { Inspecting: '#F97316', Accepted: '#16A34A', Pending: '#3B82F6', Rejected: '#EF4444' };
export default function ReceivingPage() {
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Receiving Dock</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Incoming deliveries, inspection, and receiving log</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12, marginBottom: 24 }}>
        {[{ label: 'Inspecting', count: 1, color: '#F97316' }, { label: 'Accepted', count: 1, color: '#16A34A' }, { label: 'Pending', count: 2, color: '#3B82F6' }].map(s => (
          <div key={s.label} style={{ padding: 16, background: 'var(--card)', borderRadius: 10, border: '1px solid var(--border)', textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 700, color: s.color }}>{s.count}</div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase' }}>{s.label}</div>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>{['Delivery', 'Supplier', 'PO', 'Items', 'Expected', 'Arrived', 'Dock', 'Status'].map(h => (
            <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)', background: 'rgba(15,23,42,0.3)' }}>{h}</th>
          ))}</tr></thead>
          <tbody>{DELIVERIES.map(d => (
            <tr key={d.id} style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={{ padding: '12px 16px', color: 'var(--primary)', fontSize: 13, fontWeight: 600 }}>{d.id}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600 }}>{d.supplier}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-muted)', fontSize: 12 }}>{d.po}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-secondary)', fontSize: 13 }}>{d.items}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-muted)', fontSize: 12 }}>{d.expected}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-muted)', fontSize: 12 }}>{d.arrived}</td>
              <td style={{ padding: '12px 16px', color: 'var(--text-secondary)', fontSize: 13 }}>{d.dock}</td>
              <td style={{ padding: '12px 16px' }}><span style={{ padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600, background: `${SC[d.status]}20`, color: SC[d.status] }}>{d.status}</span></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
